import type { Genres } from '~/types/genres'

export const useGenres = () => {
  const baseUrl = 'genres'

  const { fetchAll } = useApi()

  const getGenres = async () => {
    return fetchAll<Genres>(baseUrl, { page: 1, page_size: 15 })
  }

  return {
    getGenres
  }
}
